export const isWebLink = (string) =>
  /\w+\.\w+\/|\w+\.\w{2,3}([^\w]|$)|:\/\//gi.test(string);

const webLinkRegex =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+:[^\s]{2,}|www\.[a-zA-Z0-9]+:[^\s]{2,})/gim;

const linkTokensRegex = /\{\{link:(\d+)\}\}/g;

export const removeLinkTokens = (text) => text.replace(linkTokensRegex, '');

export const getLinkTokens = (text) => {
  if (typeof text !== 'string') return [];

  return Array.from(
    text.matchAll(linkTokensRegex),
    ([, matchedToken]) => matchedToken
  );
};

export const createLinkTokenText = (linkID) => `{{link:${linkID}}}`;

export const removeEmbeddedWebLinks = (text) => text.replace(webLinkRegex, '');

export const getEmbeddedWebLinks = (text) => text.match(webLinkRegex) || [];
